import { render, staticRenderFns } from "./KanbanItem.vue?vue&type=template&id=7abf9c8d&scoped=true"
import script from "./KanbanItem.vue?vue&type=script&lang=ts"
export * from "./KanbanItem.vue?vue&type=script&lang=ts"
import style0 from "./KanbanItem.vue?vue&type=style&index=0&id=7abf9c8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abf9c8d",
  null
  
)

export default component.exports